module.exports = __webpack_public_path__ + "img/erp01.59d7bedc.jpg";